import { Info } from 'lucide-react';

import { Alert, AlertDescription } from '@nesso/ui/primitives/alert';

import { formatShortDate } from '@/shared/lib/time-utils';

type Props = {
    generatedAt: Date | string | null | undefined;
};

export function SessionNoteAiDisclaimer({ generatedAt }: Props) {
    return (
        <div className="flex flex-col gap-6">
            <Alert variant="accent">
                <Info className="size-4" />
                <AlertDescription>
                    This note was generated using AI. Be sure to review and, if needed, make edits
                    for accuracy before saving to your EHR.
                </AlertDescription>
            </Alert>
            {generatedAt && (
                <p className="text-sm text-muted-foreground">
                    Note generated on {formatShortDate(generatedAt)}
                </p>
            )}
        </div>
    );
}
